<template>
	<card v-bind="cardProps" width="100%">
		<aspect-ratio-box :ratio="3/2" class="relative">
			<skeleton height="100%" width="100%"/>
		</aspect-ratio-box>

		<div class="h-88 px-16 flex flex-column justify-center">
			<skeleton class="mb-5" height="9" :min-width="60" :max-width="120" rounded/>
			<skeleton class="mb-6" height="13" :min-width="120" :max-width="180" rounded/>
			<skeleton class="mb-4" height="9" rounded/>
			<skeleton height="8" rounded/>
		</div>
	</card>
</template>

<script>
import CardMixin from "../../Card/CardMixin";

export default {
	name: 'EventCardSkeleton',

	mixins: [CardMixin],
}
</script>

